if (!customElements.get('foldinglink-about-timeline')) {
  class FoldingLinkAboutTimeline extends HTMLElement {
    connectedCallback() {
      if (this.isConnectedReady) return;
      this.isConnectedReady = true;
      this.items = Array.from(this.querySelectorAll('[data-about-timeline-item]'));
      this.rail = this.querySelector('[data-about-timeline-rail]');
      this.progress = this.querySelector('[data-about-timeline-progress]');
      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.handleScroll = this.handleScroll.bind(this);
      this.handleBlockSelect = this.handleBlockSelect.bind(this);

      if (this.prefersReducedMotion) {
        this.items.forEach((item) => item.classList.add('is-active'));
        this.progress?.style.setProperty('transform', 'scaleY(1)');
      } else {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) entry.target.classList.add('is-active');
            });
          },
          { rootMargin: '-12% 0px -34%', threshold: 0.08 }
        );
        this.items.forEach((item) => this.observer.observe(item));
        window.addEventListener('scroll', this.handleScroll, { passive: true });
        window.addEventListener('resize', this.handleScroll, { passive: true });
        this.handleScroll();
      }

      this.addEventListener('shopify:block:select', this.handleBlockSelect);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleScroll);
      this.removeEventListener('shopify:block:select', this.handleBlockSelect);
      if (this.frame) window.cancelAnimationFrame(this.frame);
      this.isConnectedReady = false;
    }

    handleScroll() {
      if (this.frame || !this.rail || !this.progress) return;
      this.frame = window.requestAnimationFrame(() => {
        const rect = this.rail.getBoundingClientRect();
        const start = window.innerHeight * 0.76;
        const end = window.innerHeight * 0.24;
        const distance = Math.max(1, rect.height + start - end);
        const value = Math.min(1, Math.max(0, (start - rect.top) / distance));
        this.progress.style.transform = `scaleY(${value})`;
        this.frame = 0;
      });
    }

    handleBlockSelect(event) {
      const item = event.target.closest?.('[data-about-timeline-item]');
      if (!item || !this.contains(item)) return;
      item.classList.add('is-active');
      if (!this.prefersReducedMotion) item.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
  }

  customElements.define('foldinglink-about-timeline', FoldingLinkAboutTimeline);
}
